module.exports = __webpack_public_path__ + "img/WP2023-Icon-ClinicalVisit.61a906b6.svg";